var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49609 6.4834H19.4961C19.8823 6.4834 20.2174 6.70237 20.384 7.02294L13.0508 11.9117C12.7149 12.1357 12.2773 12.1357 11.9414 11.9117L4.60819 7.02292C4.77477 6.70236 5.10986 6.4834 5.49609 6.4834ZM4.49609 9.3519V17.4834C4.49609 18.0357 4.94381 18.4834 5.49609 18.4834H19.4961C20.0484 18.4834 20.4961 18.0357 20.4961 17.4834V9.35191L14.1602 13.5758C13.1525 14.2476 11.8397 14.2476 10.832 13.5758L4.49609 9.3519ZM2.49609 7.4834C2.49609 5.82654 3.83924 4.4834 5.49609 4.4834H19.4961C21.1529 4.4834 22.4961 5.82654 22.4961 7.4834V17.4834C22.4961 19.1403 21.1529 20.4834 19.4961 20.4834H5.49609C3.83924 20.4834 2.49609 19.1403 2.49609 17.4834V7.4834Z",
    fill: "#6F767E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginMailIcon);
export default __webpack_public_path__ + "static/media/loginMailIcon.74e458202c0851475e1523e8db791868.svg";
export { ForwardRef as ReactComponent };